import { businessKey } from 'queryKeys';

export const PROMOCODES = 'promocodes';
const pcQuery = businessKey.query(PROMOCODES);

export const grids = pcQuery.grids();
export const grid = pcQuery.grid();

export const details = pcQuery.details();
export const model = pcQuery.exact();

const MUTATION_CREATE_SET = 'createSet';
const MUTATION_UPDATE_SET = 'updateSet';
const MUTATION_SET_RECEIVE_NOTIFICATIONS = 'setReceiveNotifications';

export const mutations = pcQuery.mutations();

export const deactivate = mutations.deactivate();
export const deleteCode = mutations.delete();
export const create = mutations.create();
export const update = mutations.update();

export const createSet = mutations.mutate(MUTATION_CREATE_SET);
export const updateSet = mutations.mutate(MUTATION_UPDATE_SET);

export const setReceiveNotifications = mutations.mutate(
  MUTATION_SET_RECEIVE_NOTIFICATIONS
);
